module.exports = __webpack_public_path__ + "img/DE03917.64a62556.png";